module.exports = __webpack_public_path__ + "img/ic-popular-active.5366f722.svg";